import { Link } from 'react-router-dom';
import { Logo } from '../components/Logo';
import './Landing.css';

export function Landing() {
  return (
    <div className="landing">
      <section className="landing__hero">
        <div className="landing__hero-content">
          <Logo className="landing__logo" />
          <h1 className="landing__title">MothNode Dashboard</h1>
          <p className="landing__subtitle">
            Real-time water tank telemetry for fire departments
          </p>
          <div className="landing__actions">
            <Link to="/dashboard" className="landing__btn landing__btn--primary">
              Go to Dashboard
            </Link>
            <Link to="/login" className="landing__btn landing__btn--secondary">
              Sign In
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Landing;
